<template>
  <v-app>
    <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
     Toolbar dunkel <v-toolbar color="#000012" fixed dark>
      <v-toolbar-title>
        <div class="topbarLogo" itemscope itemtype="http://schema.org/Organization">
          <img itemprop="logo" src="./assets/edologic.svg" @click="routeTo('/home')"/>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat class="text-none font-weight-bold">Service</v-btn>
        <v-btn flat class="text-none vledo font-weight-bold">Produkte</v-btn>
        <v-btn flat class="text-none vledo font-weight-bold">Kontakt</v-btn>
        <v-btn flat class="text-none vledo font-weight-bold">Blog</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
<!--
    <v-toolbar color="white" :fixed='true' v-if="doShowToolbar">
    <v-toolbar-title>
      <div class="topbarLogo" itemscope itemtype="http://schema.org/Organization">
        <img itemprop="logo" src="./assets/edologic.svg" @click="routeTo('/home')"/>
      </div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div class="text-xs-center">
      <v-menu
        origin="center center"
        transition="scale-transition"
        bottom class="hidden-md-and-up edomenu">
        <v-btn color="white" light slot="activator">
          <i class="fa fa-bars fa-2x menucolor"></i>
        </v-btn>
        <v-list class="edolistmenu">
          <v-list-tile v-for="(item, i) in links" :key="i">
            <v-list-tile-title @click="routeTo(item.to)">{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <v-toolbar-items class="hidden-sm-and-down edolink">
      <v-btn color="grey darken-3" to="/home" flat>Home</v-btn>
      <v-menu open-on-hover down offset-y>
        <v-btn color="grey darken-3" dark slot="activator" to="/produkte" flat>PRODUKTE</v-btn>
        <v-list>
          <v-list-tile v-for="becci in sub1" :key="becci.title" @click="routeTo(becci.to)">
            <v-list-tile-title>{{ becci.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-menu open-on-hover down offset-y>
        <v-btn color="grey darken-3" dark slot="activator" @click="routeTo('/service')" flat>SERVICE</v-btn>
        <v-list>
          <v-list-tile v-for="becci in sub2" :key="becci.title" @click="routeTo(becci.to)">
            <v-list-tile-title>{{ becci.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn color="grey darken-3" to="/edologic" flat>EDO LOGIC</v-btn>
      <v-btn color="grey darken-3" to="/ueberuns" flat>ÜBER UNS</v-btn>
      <v-btn color="grey darken-3" to="/kontakt" flat>KONTAKT</v-btn>
      <v-btn color="grey darken-3" to="/blog" flat>BLOG</v-btn>
    </v-toolbar-items>
  </v-toolbar>-->
    <router-view></router-view>

    <cookie-law buttonText="OK">
      <div slot="message">
        edologic verwendet Cookies, um Ihnen den bestmöglichen Service zu gewährleisten. Wenn Sie auf der Seite weitersurfen stimmen Sie der Cookie-Nutzung zu
        <router-link to="Impressum">Weiterlesen</router-link>
      </div>
    </cookie-law>
    <!--
    <v-card height="60px" v-if="doShowToolbar">
      <v-bottom-nav fixed :value="true" color="white">
        <v-btn flat color="grey darken-3" to="/kontakt" class="edofooter">
          KONTAKT
        </v-btn>
        <v-btn flat color="grey darken-3" to="/datenschutz" class="edofooter">
          DATENSCHUTZ
        </v-btn>
        <v-btn flat color="grey darken-3" to="/impressum" class="edofooter">
          IMPRESSUM
        </v-btn>
      </v-bottom-nav>
    </v-card>-->

    <!-- Footer dunkel ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    <v-card color="transparent" flat>
      <v-bottom-nav height="80px" dark fixed :value="true" color="#000012">
        <v-btn flat to="/kontakt" class="">
          <span>KONTAKT</span>
          <v-icon large>alternate_email</v-icon>
        </v-btn>
        <v-btn flat to="/DatenschutzNew">
          <span>DATENSCHUTZ</span>
          <v-icon large>attach_file</v-icon>
        </v-btn>
        <v-btn flat to="/ImpressumNew">
          <span>IMPRESSUM</span>
          <v-icon large>notes</v-icon>
        </v-btn>
      </v-bottom-nav>
    </v-card> ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
  </v-app>
</template>

<script>
  import Vue from 'vue'
  import CookieLaw from 'vue-cookie-law'
  export default {
    data () {
      return {
        clipped: false,
        doShowToolbar: true,
        drawer: true,
        fixed: false,
        items: [{
          icon: 'bubble_chart',
          title: 'Inspire'
        }],
        sub1: [
          {
            title: 'Crossfind',
            to: '/produkte/crossfind'
          },
          {
            title: 'Examenis',
            to: '/produkte/examenis'
          },
          {
            title: 'Surf and Scan',
            to: '/produkte/surfandscan'
          }
        ],
        sub2: [
          {
            title: 'Softwareentwicklung',
            to: '/service/softwareentwicklung'
          },
          {
            title: 'Kreation',
            to: '/service/kreation'
          },
          {
            title: 'Rechenzentrum',
            to: '/service/rechenzentrum'
          }
        ],
        links: [
          {
            title: 'Home',
            to: '/home'
          },
          { title: 'Produkte',
            to: '/produkte'
          },
          { title: 'Service',
            to: '/service' },
          { title: 'Edo Logic',
            to: '/edologic' },
          { title: 'Über Uns',
            to: '/ueberuns' },
          { title: 'Kontakt',
            to: '/contact' },
          { title: 'Blog',
            to: '/blog' }
            /*
            ,
          { title: 'Shop',
            to: 'https://shop.edologic.de/' }
           */
        ],
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'Vuetify.js'
      }
    },
    components: {CookieLaw},
    name: 'App',
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'edologic Gmbh - Geniale Projekte beginnen hier',
      // all titles will be injected into this template
      titleTemplate: '%s | edologic GmbH'
      /*
      meta: [
        {
          name: 'description',
          content: 'Individuelle Softwarelösungen - perfekt auf Sie abgestimmt. Nicht nur in der Softwareentwicklung, sondern auch im Design vorne mit dabei'
        }
      ]
      */
    },
    destroyed () {
      Vue.prototype.$eventHub.$off('OnIdle', this.OnStartIdle)
      Vue.prototype.$eventHub.$off('ShowToolbar', this.ShowToolbar)
    },
    created () {
      Vue.prototype.$eventHub.$on('OnIdle', this.OnStartIdle)
      Vue.prototype.$eventHub.$on('ShowToolbar', this.ShowToolbar)
    },
    methods: {
      OnStartIdle (idle) {
        console.log('idle', idle)
      },
      ShowToolbar (visible) {
        this.doShowToolbar = visible
      },
      routeTo (url) {
        this.$router.push(url)
        // window.location = url
      }
    }
  }
</script>

<style lang="scss">
  @import 'main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue